import React from 'react'

import { TemplatesContextController } from './context/TemplatesContextController'
import { Templates } from './templates'

export const TemplatesContainer = () => {
    return (
        <TemplatesContextController>
            <Templates />
        </TemplatesContextController>
    )
}
